<div class="w-full create-activity-one cst-content-ctnr">
  <div
    class="w-full p-8 bg-zinc-100 dark:bg-gray-800 flex-col justify-start items-start gap-2.5 inline-flex"
  >
    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    <div
      class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex"
    >
      <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
        <div
          class="w-full grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex"
        >
            <div
    class="w-fll titre self-stretch text-gray-900 text-4xl font-semibold leading-[38px]"
  >
    {{ isDuplicating ? 'Dupliquer un certificat' : 'Ajouter un nouveau certificat' }}
  </div>

          <div
            *ngIf="valid || error || inValid"
            class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          >
            <div
              class="bg-white rounded-xl shadow-xl w-full max-w-sm p-8 flex flex-col items-center gap-4 text-center"
            >
              <div *ngIf="valid" class="bg-green-100 rounded-full p-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-10 w-10 text-green-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <div *ngIf="error || inValid" class="bg-red-100 rounded-full p-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-10 w-10 text-red-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </div>

              <p class="text-lg font-medium text-gray-900">
                <ng-container *ngIf="valid">Certificat ajouté avec succès</ng-container>
                <ng-container *ngIf="error">Erreur lors de l'ajout du certificat</ng-container>
                <ng-container *ngIf="inValid">Merci de remplir tous les champs</ng-container>
              </p>

            </div>
          </div>
          <form class="w-full grow shrink" [formGroup]="certificateForm">
            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="idcertificat"
                  >ID externe du certificat</label
                >
                <input
                  [style.border]="inValidId == true ? '1px solid #EB4045' : ''"
                  formControlName="idcertificat"
                  id="idcertificat"
                  type="text"
                  placeholder="ID du certificat dans la plateforme LMS"
                  class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
                <p class="italic text-gray-500 f12 text-sm mt-1">
                  Chiffres seulement
                </p>
              </div>
              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="name"
                  >Nom certificat
                </label>
                <input
                  [style.border]="
                    inValidName == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="name"
                  id="name"
                  type="text"
                  placeholder="Nom Certificat"
                  class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="fullname"
                  >Nom complet</label
                >
                <input
                  [style.border]="
                    invalidFullname == true ? '1px solid #EB4045' : ''
                  "
                  type="text"
                  formControlName="fullname"
                  id="fullname"
                  placeholder="Modalités de participation"
                  class="w-full no-resize mb10 pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>

              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="fullname"
                  >Nom abrégé</label
                >
                <input
                  [style.border]="
                    invalidFullname == true ? '1px solid #EB4045' : ''
                  "
                  type="text"
                  formControlName="shortname"
                  id="shortname"
                  placeholder="Nom de Cohorte"
                  class="w-full no-resize mb10 pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="displayname"
                  >Nom à afficher</label
                >
                <input
                  [style.border]="
                    invalidDisplayname == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="displayname"
                  id="displayname"
                  type="text"
                  placeholder="Nom à Afficher"
                  class="w-full no-resize mb10 pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="displayname"
                  >Catégorie</label
                >

                <select
                  [style.border]="
                    invalidPlatforme == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="category"
                  id="category"
                  class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2"
                >
                  <option value="" disabled>
                    <p class="text-gray-50">Choisissez la Catégorie</p>
                  </option>
                  <option
                    *ngFor="let category of categorys"
                    [value]="category.id"
                  >
                    {{ category.categoryName }}
                  </option>
                </select>
              </div>
              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="certificatCode"
                  >Code certificat</label
                >
                <select
                  formControlName="certificatCode"
                  id="certificatCode"
                  class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2"
                >
                  <option value="" disabled>Choisissez le code</option>
                  <option *ngFor="let code of certificatCodes" [value]="code.code">
                    {{ code.label }}
                  </option>
                </select>
              </div>
            </div>

            <!-- <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="certificatCode"
                  >Code certificat</label
                >
                <select
                  formControlName="certificatCode"
                  id="certificatCode"
                  class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2"
                >
                  <option value="" disabled>Choisissez le code</option>
                  <option *ngFor="let code of certificatCodes" [value]="code.code">
                    {{ code.label }}
                  </option>
                </select>
              </div>
              <div class="w-full pr-db justify-start items-center gap-5"></div>
            </div> -->

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="plateforme"
                  >Plateforme</label
                >
                <select
                  [style.border]="
                    invalidPlatforme == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="plateforme"
                  id="plateforme"
                  class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2"
                >
                  <option value="" disabled>
                    <p class="text-gray-50">Choisissez la plateforme LMS</p>
                  </option>
                  <option *ngFor="let platform of platforms" [value]="platform">
                    {{ platform }}
                  </option>
                </select>
              </div>
              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="urlCertificat"
                  >URL certificat</label
                >
                <input
                  [style.border]="invalidUrl == true ? '1px solid #EB4045' : ''"
                  formControlName="urlCertificat"
                  id="urlCertificat"
                  type="url"
                  placeholder="Lien vers le certificat"
                  class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="startdate"
                  >Date de début
                </label>
                <input
                  [style.border]="
                    inValidStartdate == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="startdate"
                  id="startdate"
                  type="date"
                  class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 block"
                />
              </div>
              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="enddate"
                  >Date de fin</label
                >
                <input
                  [style.border]="
                    inValidEnddate == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="enddate"
                  id="enddate"
                  type="date"
                  class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 block"
                />
              </div>
            </div>

            <!-- ///// -->
            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db justify-start items-center gap-5">
                <label
                  class="mb-2 pr-db font-medium color-gray-700 w-full"
                  for="cohorte"
                  >Cohorte</label
                >
                <select
                  class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2"
                  formControlName="cohorte"
                  id="cohorte"
                  formControlName="cohorte"
                >
                  <option value="">Sélectionner une cohorte</option>
                  <option
                    *ngFor="let cohorte of cohortes"
                    [value]="cohorte.cohorteName"
                  >
                    {{ cohorte.cohorteName }}
                  </option>
                </select>
                <!-- Message d'erreur si aucune cohorte n'est sélectionnée -->
                <!-- <div *ngIf="invalidCohorte" class="text-red-500 text-sm mt-1">
                  Veuillez sélectionner une cohorte
                </div> -->
              </div>
              <div class="w-full pr-db justify-start items-center gap-5"></div>
            </div>

            <div
              class="py-3 form-fields-ctnr pr-db w-full wysiwyg-ctnr self-stretch justify-start items-start gap-6"
            >
              <label
                class="mb-2 pr-db font-medium color-gray-700 w-full"
                for="description"
                >Description du certificat</label
              >
              <textarea
                [style.border]="
                  invalidDescription == true ? '1px solid #EB4045' : ''
                "
                formControlName="description"
                id="description"
                placeholder="Description du  certificat"
                class="w-full no-resi ze pr-db mt-3 mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                maxlength="300"
              ></textarea>
              <div class="italic text-gray-500 f12 text-sm">
                300 caractères autorisés
              </div>
            </div>

            <div
  class="mt-4 field-ctnr fake-drag-n-drop pt-7 gap-5 text-center px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center"
>
  <label class="mt-9 mb-1 pr-db font-medium text-gray-900 w-full" for="ledocument">
    Ajouter une image<br />
    <span>(PNG, JPEG)</span>
  </label>

  <!-- État : chargement de l'image dupliquée -->
  <label *ngIf="isLoadingDuplicatedImage" class="mb-2 pr-db font-medium text-blue-500 w-full">
    Récupération de l'image du certificat original...
  </label>

  <label *ngIf="!isLoadingDuplicatedImage && fileSize == undefined" class="mb-2 pr-db font-medium text-gray-400 w-full" for="ledocument">
    La taille de l'image doit etre compris entre 100ko et 2 Mo
  </label>
  <label *ngIf="!isLoadingDuplicatedImage && minSize < fileSize && fileSize < maxFileSize" class="mb-2 pr-db font-medium w-full text-green-500" for="ledocument">
    {{ fileName }}
  </label>
  <label *ngIf="!isLoadingDuplicatedImage && (minSize > fileSize || fileSize >= maxFileSize)" class="mb-2 pr-db font-medium text-red-500 w-full" for="ledocument">
    La taille de l'image doit etre compris entre 100ko et 2 Mo
  </label>

  <input
    id="ledocument"
    type="file"
    accept="image/*"
    class="w-full pr-db mat-mdc-input-element self-stretch none"
    (change)="onChange($event)"
  />
</div>

            <div
              class="form-fields-ctnr reset-submit w-full self-stretch justify-end items-end gap-6 inline-flex"
            >
              <div class="w-full flex pt-8 justify-end items-end gap-2">
                <input
                  type="reset"
                  value="Annuler"
                  (click)="resetCreation()"
                  style="border-radius: 0.5rem"
                  class="text-sm font-semibold bg-red bg-redDark transition text-white mat-mdc-input-element self-stretch px-2.5 py-2.5 shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
                <input
                  type="submit"
                  value="Sauvegarder"
                  (click)="openConfirmModal()"
                  style="border-radius: 0.5rem"
                  class="text-sm font-semibold bg-blue bg-blueDark transition text-white mat-mdc-input-element self-stretch px-2.5 py-2.5 shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal de confirmation -->
  <div
    *ngIf="showConfirmModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="bg-white rounded-xl shadow-xl w-full max-w-md p-8 flex flex-col gap-6"
    >
      <!-- Icône + Titre -->
      <div class="flex flex-col items-center gap-3 text-center">
        <div class="bg-blue-100 rounded-full p-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-10 w-10 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h2 class="text-2xl font-semibold text-gray-900">
          Confirmer la création
        </h2>
        <p class="text-slate-600 text-base">
          Vous êtes sur le point d'ajouter un nouveau certificat.<br />
          Voulez-vous confirmer cette action ?
        </p>
      </div>

      <!-- Récapitulatif -->
      <div
        class="bg-zinc-50 rounded-lg border border-gray-200 px-5 py-4 text-sm text-gray-700 flex flex-col gap-2"
      >
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Nom :</span>
          <span class="font-semibold">{{
            certificateForm.get("name")?.value
          }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Nom abrégé :</span>
          <span>{{ certificateForm.get("shortname")?.value }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Plateforme :</span>
          <span>{{ certificateForm.get("plateforme")?.value }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Cohorte :</span>
          <span>{{ certificateForm.get("cohorte")?.value }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Date de début :</span>
          <span>{{ certificateForm.get("startdate")?.value }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Date de fin :</span>
          <span>{{ certificateForm.get("enddate")?.value }}</span>
        </div>
        <div class="flex justify-between" *ngIf="fileName">
          <span class="font-medium text-gray-500">Fichier :</span>
          <span class="truncate max-w-[200px]">{{ fileName }}</span>
        </div>
        
      </div>

      <!-- Boutons -->
      <div class="flex justify-end gap-3">
        <button
          (click)="cancelSubmit()"
          class="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-100 transition focus:outline-none"
        >
          Annuler
        </button>
        <button
          (click)="confirmSubmit()"
          class="px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-700 text-white font-bold transition focus:outline-none"
        >
          Confirmer
        </button>
      </div>
    </div>
  </div>
</div>
